import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from '../icons/Icon';

type Variant = 'default' | 'primary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'md' | 'sm';
  icon?: IconName;
  /** Icon-only button: the label becomes the accessible name (rule 12). */
  iconOnly?: boolean;
  block?: boolean;
  children?: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  default: '',
  primary: 'pri',
  ghost: 'ghost',
  danger: 'dngr',
};

/** One gold primary per screen; destructive actions have red border and text, never a fill (rule 6). */
export function Button({
  variant = 'default',
  size = 'md',
  icon,
  iconOnly = false,
  block = false,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [
    'btn',
    VARIANT_CLASS[variant],
    size === 'sm' ? 'sm' : '',
    iconOnly ? 'ico' : '',
    block ? 'block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button
      type={type}
      className={classes}
      aria-label={iconOnly && typeof children === 'string' ? children : undefined}
      {...rest}
    >
      {icon === undefined ? null : <Icon name={icon} size={size === 'sm' ? 13 : 15} />}
      {iconOnly ? null : children}
    </button>
  );
}
